import React from 'react';
import { Container, Paper, Typography } from '@material-ui/core';
import BarChart from 'components/@common/Charts/BarChart';
import useStyles from '../common/styles';
import { PrmStudentCurriculumLessonReportResult } from 'types/schema-generated-types';
type Props = {
  studentLessonReport: PrmStudentCurriculumLessonReportResult;
};
const StudentLessonChart: React.FC<Props> = ({ studentLessonReport }) => {
  const classes = useStyles();
  const buildSeries = (studentLessonReport: PrmStudentCurriculumLessonReportResult) => {
    const data =
      studentLessonReport?.lessonDetail?.lessons.map(x =>
        Math.round((x.timeSpentSeconds! ?? 0) / 60)
      ) ?? [];

    return [{ data }];
  };

  const buildOptions = (studentLessonReport: PrmStudentCurriculumLessonReportResult) => {
    return {
      tooltip: {
        y: {
          formatter: (data: any) => `${data} minutes`,
          title: {
            formatter: () => 'Time Spent:'
          }
        }
      },
      stroke: {
        width: [0, 4]
      },
      legend: {
        show: false
      },
      dataLabels: {
        enabled: true,
        enabledOnSeries: [1]
      },
      labels: studentLessonReport?.lessonDetail?.lessons.map(
        x => `Lesson ${x?.lesson?.lessonNumber}`
      ) ?? [''],
      yaxis: [
        {
          title: {
            text: 'Minutes'
          }
        }
      ],
      grid: {
        padding: {
          bottom: -10
        }
      }
    };
  };

  return (
    <Paper className={classes.container}>
      <Container>
        <BarChart
          series={buildSeries(studentLessonReport)}
          options={buildOptions(studentLessonReport)}
          height={210}
        />
        <Typography>Average Time Per Lesson</Typography>
        <Typography variant="h3">
          {Math.round(studentLessonReport?.lessonDetail?.averageLessonTimeSpentSeconds! / 60)}{' '}
          minutes
        </Typography>
      </Container>
    </Paper>
  );
};

export default StudentLessonChart;
